<template>
  <nav class="navigation">
    <ul
      id="MAIN_NAVIGATION_MENU"
      class="navigation__list"
    >
      <li
        v-for="(category, index) in shopCategoriesTree"
        :key="`category_${index}`"
        class="navigation__element"
      >
        <a
          :href="category.url"
          class="navigation__link"
        >{{ category.name }}</a>
        <navigation-flyout
          v-if="category.subcategories && category.subcategories.length"
          class="navigation__flyout"
          :categories="category.subcategories"
          :flyout-image="category.flyoutImage"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import NavigationFlyout from '../navigationFlyout/navigationFlyout.vue';

  export default {
    mixins: [
      globalStateComputedMixin
    ],
    components: {
      NavigationFlyout
    }
  };

</script>
